// Delegated events also work after Shopify replaces a section in the theme editor.
if (!window.offrizzSizeGuideReady) {
  window.offrizzSizeGuideReady = true;
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-size-guide-open]');
    if (opener) {
      const dialog = opener.closest('[data-offrizz-size-guide]')?.querySelector('dialog');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-size-guide-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.matches('dialog.offrizz-size-guide-dialog')) event.target.close();
  });
}
